import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../../../FirebaseConfig";
import { updateDataByID } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";

const getParseData = (item) => {
  if (item) {
    try {
      return typeof item === "string" ? JSON.parse(item) : null;
    } catch (error) {
      console.error("Parsing error:", error);
    }
  }
  return null;
};

const DeleteAllComponent = ({ open, onClose, componentData }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setLoading(false);
    }
  }, [open]);

  const handleDeleteSubCategory = async () => {
    setLoading(true);
    try {
      await removeSubCategoryDetail();
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error deleting sub-category:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setLoading(false);
    onClose();
  };

  const removeSubCategoryDetail = async () => {
    try {
      let all_items_of_cat = componentData?.category?.items;

      if (!all_items_of_cat) {
        console.error("No items found in category.");
        return;
      }

      for (let i = 0; i < all_items_of_cat.length; i++) {
        let item = getParseData(all_items_of_cat[i]);

        if (item && item.l_s_c_d_id?.length > 0) {
          for (let docID of item.l_s_c_d_id) {
            const docRef = doc(
              db,
              "library_sidebar_category_details_collection",
              docID
            );
            await deleteDoc(docRef);
          }
        }
      }

      const mainDocRef = doc(
        db,
        "library_sidebar_categories_collection",
        componentData?.category?.id
      );
      await deleteDoc(mainDocRef);

      console.log(
        ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> deleted successfully"
      );
    } catch (error) {
      console.error(
        " >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> sub-category detail:",
        error
      );
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
        }}
      >
        {loading ? (
          <LoadingCircular />
        ) : (
          <>
            <DialogTitle>
              Are you sure you want to delete this sub-category?
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCancelDelete} color="primary">
                No
              </Button>
              <Button
                onClick={handleDeleteSubCategory}
                color="secondary"
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
};

export default DeleteAllComponent;
